export default "__VITE_ASSET__BHLZRUpq__"